import { Link } from "react-router-dom";

function viewLinkClass(active) {
  return [
    "feature-company-work__view-switch-link",
    active ? "feature-company-work__view-switch-link--active" : "",
  ]
    .filter(Boolean)
    .join(" ");
}

function CompanyWorkViewSwitch({ listHref, calendarHref, activeView }) {
  const listActive = activeView === "list";
  const calendarActive = activeView === "calendar";

  return (
    <nav
      className="feature-company-work__view-switch"
      aria-label="Режим перегляду"
    >
      <Link
        to={listHref}
        className={viewLinkClass(listActive)}
        aria-current={listActive ? "page" : undefined}
      >
        Список
      </Link>
      <Link
        to={calendarHref}
        className={viewLinkClass(calendarActive)}
        aria-current={calendarActive ? "page" : undefined}
      >
        Календар
      </Link>
    </nav>
  );
}

export default CompanyWorkViewSwitch;
